<template>
  <Modal
    :value="showModal"
    :title="'添加人员'"
    :mask-closable="false"
    width="600"
    @on-cancel="ManagerQuxiao"
  >
    <div class="box table-box">
      <div class="right-text">姓名</div>
      <AutoComplete
        v-model="autoValue"
        @on-search="searchManger"
        @on-select="selectAuto"
        :placeholder="'请选择人员...'"
      >
        <Option v-for="(item, index) in userlist" :value="index" :key="index"
          >{{ item.realName }}({{ item.userName || "无昵称" }})</Option
        >
      </AutoComplete>
    </div>
    <div slot="footer">
      <Button type="text" @click="ManagerQuxiao">取消</Button>
      <Button type="primary" @click="addMember">确定</Button>
    </div>
  </Modal> 
</template>

<script>
export default {
  props: {
    showModal: {
      //控制是否显示搜索弹窗
      type: Boolean,
      default: false
    },
    positionId: "",
    passStation: null,
    userListIndex: {
    //  type: Number,
    },
  },
  data() {
    return {
      autoValue: "",
      selectMember: "",
      userlist: [], //搜索弹窗中搜索结果
      id: "",
      valueChange: false,
      page: 1,
      jobList: [],
    };
  },
  computed: {},
  watch: {
    passStation(newValue, oldValue) {
      console.log(newValue)
      if (newValue) {
        this.autoValue = newValue.realName;
        this.id = newValue.id;
        this.selectMember = newValue;
      } else {
        this.autoValue = "";
        this.selectMember = "";
        this.id = "";
      }
    }
  },
  methods: {
    // 添加人员
    addMember(index) {
      console.log(index)
      var that = this;
      let url = this.urlobj.addStation;
      var selectMember = "";
      if (this.valueChange) {
        that.userlist.forEach(item => {
          if (
            item.unionId == that.selectMember.unionId &&
            (item.realName == that.autoValue || item.userName == that.autoValue)
          ) {
            selectMember = item;
          }
        });
      } else {
        selectMember = this.selectMember;
      }
      // if (!selectMember) {
      //   that.$Message.warning("请选择人员...");
      //   return;
      // }
      let data = {
        zoneId: sessionStorage.zoneId,
        // personUid: selectMember.uid, // 目前是单选 就取 0
        // id: this.id,
        positionId: this.positionId,
        // personName: selectMember.realName || selectMember.userName
        personName: this.autoValue,
      };
      if(selectMember) {
        data.personName = selectMember.realName || selectMember.userName;
        data.personUid = selectMember.uid
      }
      this._showSpin();
      this.$post(url, data)
        .then(res => {
          this.page = 1;
          this.valueChange = false;
          if (res.isSucceed) {
            // 拼接用户数据
            if (that.id) this.$Message.success("修改成功");
            else this.$Message.success("添加成功");
            let _t = {
              headPicUrl: selectMember.headPicUrl || "",
              realName: that.autoValue,
              personUid: selectMember.uid || "",
              id: res.newPrimaryKeys.id,
              change: that.id ? true : false,
              index: that.userListIndex
            };
            this.$emit("addStation", _t);
            this._initProp();
          }
        })
        .catch(e => console.log(e));
    },
    // 取消按钮
    modalCancel() {
      this._initProp();
    },
    _searchManger(value) {
      if (this.page != 1 || !this.id) this.valueChange = true;
      var that = this;
      var url = this.urlobj.stationUser;
      this.$post(url, {
        pageNum: 1,
        pageSize: 10,
        userName: value
      }).then(res => {
        that.page++;
        that.isData = false;
        var list = [];
        res.rows.map(item => {
          list.push({
            realName: item.realName,
            headPicUrl: item.headPicUrl,
            userName: item.userName,
            unionId: item.unionId,
            uid: item.uid,
            id: item.id
          });
        });
        that.userlist = list;
      });
    },
    selectAuto(value) {
      var autoValue = this.userlist[value];
      this.$nextTick(() => {
        this.autoValue = autoValue.realName || autoValue.userName; // 更新地点
      });
      this.selectMember = autoValue;
    },
    // 初始化数据
    _initProp() {
      this.modelInput = "";
      this.userlist = [];
      this.$emit("modalCancel");
    },
    _showSpin() {
      this.showSpin = true;
    },
    _hideSpin() {
      this.showSpin = false;
    },
    ManagerQuxiao() {
      this.$emit("quxiao");
    }
  },
  components: {},
  mounted() {},
  created() {
    this.searchManger = this._.debounce(this._searchManger, 500);
  }
};
</script>
<style lang="less" scoped>
.modelInput {
  margin-top: 10px;
}
.searchcard-wrapper {
  position: relative;
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  height: 180px;
  overflow-y: scroll;
}
.search-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 150px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  position: relative;
}

.img img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.search-name {
  margin-top: 10px;
  color: #4b4b4b;
  font-weight: 600;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
.searchcard-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.select {
  border: 1px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}

.table-box {
  align-items: center;
  margin-bottom: 30px;
}
.right-text {
  width: 70px;
  text-align: right;
  margin-right: 10px;
}
</style>
